import { Grid } from '@material-ui/core';
import EmptyJournalSinistre from 'components/AccordionSinistre/EmptyJournalSinistre';
import { SecondaryButton } from 'components/Button';
import ChevronCardButtonList from 'components/ChevronCardButtonList';
import {
  DarkGray,
  LightGray,
} from 'containers/AUTODashboard/Body/FrequentlyAskedQuestions/colors';
import messages from 'containers/AUTODashboard/Body/FrequentlyAskedQuestions/messages';
import {
  FaqContainer,
  FaqWrapper,
  StyledSmallSectionHeader,
  useButtonStyles,
} from 'containers/AUTODashboard/Body/FrequentlyAskedQuestions/styles';
import GaClickHOC from 'helpers/GATracking/GaClickHOC';
import { translate } from 'helpers/intl';
import { pushTo } from 'helpers/routes';
import { sanlamPureBlue, sanlamVeryDarkBlue } from 'Material-UI/colors';
import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import PAGES from 'routes/pages';
import { uppercase } from 'utils/string';
export interface FrequentlyAskedQuestionsPropsType {
  intl: IntlShape;
  items: any;
  GACategoryAllResponses: string;
}

const FrequentlyAskedQuestions = (props: FrequentlyAskedQuestionsPropsType) => {
  const classes = useButtonStyles();
  return (
    <FaqContainer padding={3}>
      <FaqWrapper container>
        <Grid xs={12} item>
          <Grid
            alignItems="center"
            justify="space-between"
            style={{ marginBottom: '18px' }}
            container
          >
            <Grid xs={6} item>
              <StyledSmallSectionHeader color={sanlamVeryDarkBlue}>
                {translate({ ...messages.questionsFrequents }, props)}
              </StyledSmallSectionHeader>
            </Grid>
            <Grid xs={6} sm={4} md={6} item>
              <GaClickHOC
                category={props.GACategoryAllResponses}
                label="FAQ_Toutes nos réponses"
              >
                <SecondaryButton
                  fontColor={sanlamPureBlue}
                  data-testid="all-responses"
                  onClick={() => {
                    pushTo(PAGES.FAQ);
                  }}
                  classes={{ root: classes.root }}
                >
                  {uppercase(translate({ ...messages.allResponses }, props))}
                </SecondaryButton>
              </GaClickHOC>
            </Grid>
          </Grid>
        </Grid>
        {props.items ? (
          <ChevronCardButtonList
            items={props.items}
            backgroundColor={LightGray}
            borderColor={DarkGray}
            mdGrid={12}
            smGrid={6}
            borderRadius="4px"
            spacing={1}
          />
        ) : (
          <EmptyJournalSinistre />
        )}
      </FaqWrapper>
    </FaqContainer>
  );
};

export default injectIntl(FrequentlyAskedQuestions);
